export default __webpack_public_path__ + "static/media/A&Q_Logo.392c907c.svg";